import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const TermsOfUse = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="max-w-4xl mx-auto px-6 py-16">
        <div className="prose prose-lg max-w-none">
          <h1 className="text-4xl font-bold text-gray-800 mb-8">Términos de Uso</h1>
          
          <p className="text-gray-600 mb-6">
            <strong>Última actualización:</strong> {new Date().toLocaleDateString('es-ES')}
          </p>

          <div className="space-y-8">
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Información General</h2>
              <p className="text-gray-600 leading-relaxed">
                Estos términos de uso regulan el acceso y uso de los servicios de Innova2Market, 
                empresa especializada en automatización e inteligencia artificial. Al utilizar 
                nuestros servicios, aceptas estos términos en su totalidad.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Servicios Ofrecidos</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Innova2Market proporciona servicios de:
              </p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2">
                <li>Desarrollo e implementación de sistemas de IA y automatización</li>
                <li>Asistentes telefónicos inteligentes</li>
                <li>Chatbots y sistemas de conversación automatizada</li>
                <li>Automatización de procesos empresariales</li>
                <li>Consultoría en transformación digital</li>
                <li>Integración con plataformas de ecommerce</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Obligaciones del Cliente</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                El cliente se compromete a:
              </p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2">
                <li>Proporcionar información veraz y actualizada</li>
                <li>Colaborar activamente en el desarrollo del proyecto</li>
                <li>Facilitar el acceso a sistemas y datos necesarios</li>
                <li>Realizar los pagos según lo acordado</li>
                <li>Utilizar los servicios de acuerdo con la legislación aplicable</li>
                <li>No utilizar los servicios para actividades ilegales o fraudulentas</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Obligaciones de Innova2Market</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Nos comprometemos a:
              </p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2">
                <li>Proporcionar servicios de calidad profesional</li>
                <li>Mantener la confidencialidad de la información del cliente</li>
                <li>Cumplir con los plazos acordados</li>
                <li>Ofrecer soporte técnico durante el período acordado</li>
                <li>Respetar la normativa de protección de datos</li>
                <li>Mantener la seguridad de los sistemas implementados</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Propiedad Intelectual</h2>
              <p className="text-gray-600 leading-relaxed">
                Los derechos de propiedad intelectual sobre las soluciones desarrolladas específicamente 
                para el cliente serán transferidos al cliente una vez completado el pago. Innova2Market 
                conserva los derechos sobre su metodología, herramientas y conocimientos generales.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Confidencialidad</h2>
              <p className="text-gray-600 leading-relaxed">
                Ambas partes se comprometen a mantener la confidencialidad de toda la información 
                compartida durante la prestación de servicios. Esta obligación permanecerá vigente 
                incluso después de la finalización del contrato.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Limitación de Responsabilidad</h2>
              <p className="text-gray-600 leading-relaxed">
                Innova2Market no será responsable de daños indirectos, lucro cesante o pérdidas 
                consecuenciales. Nuestra responsabilidad se limitará al importe de los servicios 
                efectivamente pagados por el cliente.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Garantías y Soporte</h2>
              <p className="text-gray-600 leading-relaxed">
                Ofrecemos garantía sobre el funcionamiento de las soluciones implementadas según 
                las especificaciones acordadas. El soporte técnico se proporciona según los términos 
                específicos de cada contrato.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Modificaciones del Servicio</h2>
              <p className="text-gray-600 leading-relaxed">
                Nos reservamos el derecho de modificar o discontinuar servicios con previo aviso. 
                Los cambios no afectarán a los servicios ya contratados y en funcionamiento.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Resolución de Conflictos</h2>
              <p className="text-gray-600 leading-relaxed">
                Cualquier disputa será resuelta mediante negociación directa. En caso de no alcanzar 
                un acuerdo, se someterá a los tribunales competentes de España, aplicándose la 
                legislación española.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Fuerza Mayor</h2>
              <p className="text-gray-600 leading-relaxed">
                No seremos responsables del incumplimiento de obligaciones debido a circunstancias 
                de fuerza mayor, incluyendo pero no limitado a desastres naturales, conflictos 
                armados, o fallos en servicios de terceros.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">12. Contacto</h2>
              <p className="text-gray-600 leading-relaxed">
                Para cualquier consulta sobre estos términos de uso:
              </p>
              <div className="bg-gray-50 p-4 rounded-lg mt-4">
                <p className="text-gray-700">
                  <strong>Email:</strong> info@innova2market.es<br/>
                  <strong>Teléfono:</strong> +34 604 97 16 08
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">13. Modificaciones</h2>
              <p className="text-gray-600 leading-relaxed">
                Estos términos pueden ser modificados en cualquier momento. Las modificaciones 
                entrarán en vigor inmediatamente tras su publicación en nuestro sitio web.
              </p>
            </section>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default TermsOfUse;
